import ApiService from './api.service.js'
import { isConstructorDeclaration } from 'typescript'



const masterpayerService = {

  getAllMyMasterpayerRequest: async function (requestor_id, callback) {
    try {
      let masterpayerRequestBody = {
        params: {
          action: 'masterpayer-request-by-requestor',
          Requestor_Id : requestor_id
        }
      }

      let mpResponse = await ApiService.get(process.env.VUE_APP_MASTERPAYER_API, masterpayerRequestBody)
      
      if(mpResponse.data.hasOwnProperty('result') && mpResponse.data.result){
        callback(null, mpResponse.data.result)
      } else {
        callback(mpResponse.data.error, null )
      }
    } catch(error) {
      console.log(error)
      callback(error)
    }
  },

  getMasterpayerRequest: async function (id, callback) {
    try {
      let params = { action: 'masterpayer-request' }

      if (id) {
        params = {
          ...params,
          Master_Id : id,
          action: 'masterpayer-request-detail'
        }
      }
      
      let masterpayerRequestBody = {
        params: {
          ...params
        }
      }

      let mpResponse = await ApiService.get(process.env.VUE_APP_MASTERPAYER_API, masterpayerRequestBody)
      
      if(mpResponse.data.hasOwnProperty('result') && mpResponse.data.result){
        callback(null, mpResponse.data.result)
      } else {
        callback(mpResponse.data.error, null )
      }
    } catch(error) {
      console.log(error)
      callback(error)
    }
  },

  setMasterpayerStatus: async function (data, callback) {

    try {
      let submitMasterpayerBody = {
        action: 'update-masterpayer-status',
        ...data,
        controlTowerRegions: JSON.stringify(data.controlTowerRegions)
      }

      console.log(submitMasterpayerBody)
      
      let masterpayerResponse = await ApiService.post(process.env.VUE_APP_MASTERPAYER_API, submitMasterpayerBody)
      console.log(masterpayerResponse)
  
      if (masterpayerResponse.data.result) {
        callback(null, masterpayerResponse.data.result)
      } 
    } catch (error) {
      console.log(error)
      callback(error, null)
    }
    
  },

  masterpayerSubmit: async function (data, callback) {

    try {
      let submitMasterpayerBody = {
        action: 'submit-masterpayer',
        ...data,
        status: 'New',
        controlTowerRegions: JSON.stringify(data.controlTowerRegions)
      }
      
      let masterpayerResponse = await ApiService.post(process.env.VUE_APP_MASTERPAYER_API, submitMasterpayerBody)
      console.log(masterpayerResponse)
  
      if (masterpayerResponse.data.result) {
        callback(null, masterpayerResponse.data.result)
      } 
    } catch (error) {
      console.log(error)
      callback({error: error}, null)
    }
    
  },
  
}

export default masterpayerService
  